<template>
  <b-radio-button v-model="selectedValue"
                  :native-value="nativeValue"
                  @input="updateValue"
                  :type="theme">
    <span>{{ label }}</span>
  </b-radio-button>
</template>

<script>
export default {
  name: 'RadioButton',
  // data () {
  //   return {
  //     label: '',
  //     selectedValue: '',
  //     nativeValue: '',
  //     theme: ''
  //   }
  // },
  model: {
    prop: 'selectedValue',
    event: 'change'
  },
  props: {
    label: '',
    selectedValue: '',
    nativeValue: '',
    theme: ''
  },
  methods: {
    updateValue (selectedValue) {
      this.$emit('change', selectedValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/RadioButton.vue